"use client";

import { ProductFilteredListContainer } from "containers/ProductFilteredList/ProductFilteredList";
import { UseProductFilteredListCreateContextParams } from "containers/ProductFilteredList/hooks";
import { ProductUrlGenerator } from "hooks/useProductUrlGenerator";

import { CurationProductClickEvent } from "@holibob-packages/ui-core/custom-events";

import { CurationProps } from "./CurationV2";

const TREE_IDS: UseProductFilteredListCreateContextParams["treeIds"] = ["CATEGORY", "ATTRIBUTE", "PROVIDER", "PRICE"];

type CurationProductsFilteredListV2Props = {
    curation: CurationProps["curation"];
    urlGenerator: ProductUrlGenerator;
    showTitle: boolean;
};

export function CurationProductsFilteredListV2({
    curation,
    showTitle,
    urlGenerator,
}: CurationProductsFilteredListV2Props) {
    const filter = { curationSlugId: curation.id };

    return (
        <ProductFilteredListContainer
            filter={filter}
            treeIds={TREE_IDS}
            searchTerm={curation.name}
            showTitle={showTitle}
            showFiltersTree={true}
            onProductClick={(event, data) => {
                event.target.dispatchEvent(new CurationProductClickEvent(data));
            }}
            urlGenerator={urlGenerator}
            hideUnlessProducts
        />
    );
}
